import { chartColors } from "../../../../../infrastructure/theme/customColors";

const colors = chartColors.split(",");

export const getIconColor = (index) => colors[index % colors.length];
